import { LinkedIn } from '@material-ui/icons';
import RenderProfilePic from '../../../extras/RenderProfilePic';

export default function UserDetails({ user, compact = false }) {
  return (
    <div className='flex items-center gap-2 text-black text-opacity-60'>
      <RenderProfilePic
        thumbnail={user.thumbnail}
        name={user.firstName}
        size={3}
      />
      <span>
        {user.firstName} {user.lastName}
      </span>
      <a href={user.linkedInUrl} target='_blank' rel='noopener noreferrer'>
        <LinkedIn htmlColor='#0275B4' />
      </a>
      {!compact && (
        <>
          <span className='h-6 mx-3 bg-gray-300' style={{ width: '1px' }} />
          <span>{user.phone}</span>
          <span className='h-6 mx-3 bg-gray-300' style={{ width: '1px' }} />
          <span>{user.email}</span>
        </>
      )}
    </div>
  );
}
